/* eslint-disable import/no-mutable-exports */
/* eslint-disable @typescript-eslint/no-explicit-any */

// Create an appropriate interface for the APM instance
interface ApmInstance {
  captureError: (error: any) => void;
  setUserContext: (context: any) => void;
  setCustomContext: (context: any) => void;
  addLabels: (labels: any) => void;
  startTransaction: (name: string, type?: string) => any;
  getCurrentTransaction: () => any | null;
}

// Use require instead of dynamic import since webpack will handle this through externals
let apmInstance: ApmInstance;

if (typeof window === 'undefined') {
  // Server-side - directly use the server config
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  apmInstance = require('./serverSideLoggingConfig').default;
} else {
  // Browser-side - use client config
  // eslint-disable-next-line global-require, @typescript-eslint/no-var-requires
  apmInstance = require('./clientSideLoggingConfig').default;
}

export default apmInstance;
